import { Skeleton } from 'antd';
import React, { MouseEventHandler } from 'react';

import pdfIcon from '@/assets/file-icons/pdf.png';
import { useContractPdf } from '@/features/contracts/api/use-download-contract';
import { downloadFile } from '@/utils/download-file';

type Props = {
  contractId: number;
};

const DownloadContractButton = ({ contractId }: Props) => {
  const contractPdfQuery = useContractPdf({
    params: { contractId },
    queryConfig: { enabled: false },
  });

  const handleDownload: MouseEventHandler<HTMLButtonElement> = async (event) => {
    event.stopPropagation();

    const {
      data: { data: blob },
    } = await contractPdfQuery.refetch();
    downloadFile(blob, `${contractId}.pdf`);
  };

  return (
    <button onClick={handleDownload} disabled={contractPdfQuery.isLoading}>
      {contractPdfQuery.isLoading ? (
        <Skeleton.Node className="rounded-sm w-6 h-6" active />
      ) : (
        <img src={pdfIcon} alt="pdf-icon" width={24} height={24} />
      )}
    </button>
  );
};

export default DownloadContractButton;
